import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { icons } from 'lucide';

@Injectable({providedIn: 'root'})
export class IconsService
{
    /**
     * Constructor
     */
    constructor()
    {
        const domSanitizer = inject(DomSanitizer);
        const matIconRegistry = inject(MatIconRegistry);

        // Register icon sets
        matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'));
        matIconRegistry.addSvgIconSetInNamespace('mat_outline', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'));
        matIconRegistry.addSvgIconSetInNamespace('mat_solid', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'));
        matIconRegistry.addSvgIconSetInNamespace('feather', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'));
        matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline.svg'));
        matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'));
        matIconRegistry.addSvgIconSetInNamespace('heroicons_mini', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-mini.svg'));
    
        // Register Lucide icons
        console.log('Registering Lucide icons...');
        let registeredCount = 0;
        for (const [name, data] of Object.entries(icons)) {
            // Convert lucide icon data to SVG string
            const paths = (data as any[]).map((element: any) => {
                const [tag, attrs] = element;
                const attrString = Object.entries(attrs || {})
                    .map(([key, value]) => `${key}="${value}"`)
                    .join(' ');
                return `<${tag} ${attrString}/>`;
            }).join('');

            const svgString = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;

            // Convert PascalCase to kebab-case, handling numbers correctly
            // e.g., "Home" -> "home", "ArrowRight" -> "arrow-right", "Columns3" -> "columns-3"
            const kebabName = name
                .replace(/([a-z0-9])([A-Z])/g, '$1-$2')  // lowercase/number to uppercase
                .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')  // uppercase to uppercase-lowercase
                .toLowerCase()
                .replace(/([a-z])(\d)/g, '$1-$2');  // letter to number

            matIconRegistry.addSvgIconLiteral(
              `lucide-${kebabName}`,
              domSanitizer.bypassSecurityTrustHtml(svgString)
            );
            registeredCount++;

            // Log the first few for verification
            if (registeredCount <= 3) {
                console.log(`Registered: lucide-${kebabName}`, svgString.substring(0, 100));
            }
        }
        console.log(`Registered ${registeredCount} Lucide icons`);
    }
}
